import type { TerminalCopyDto } from "src/app/features/Terminal/types/TerminalCopyDto";
import type { TerminalCopyEntity } from "src/app/features/Terminal/types/TerminalCopyEntity";

export const TerminalCopyEntityToCopyDto = ({ ...rest }: Readonly<TerminalCopyEntity>): TerminalCopyDto => {
    return { ...rest };
};
